/// <reference path="../../../../../rcwebmodels/reeferdetails.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/unitdetailsui.cs.d.ts" />
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as ReeferStatusState from '../../store/ReeferStatus';
import * as UserDetailState from '../../store/UserDetails';
import { ReeferDetailsHistory } from '../childcomponents/ReeferDetailsHistory';
import { ReeferDetailsCommandStatus } from '../childcomponents/ReeferDetailsCommandStatus';
import DetailsMap from '../../actions/DetailsMap';
import { RCUtils } from './../../RCUtils';
import $ from 'jquery';
import * as Exceljs from '../../actions/ExportToExcel.js';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { PingControl } from './../sharedcomponents/ForwardCommands/PingControl';
import { TempSetPoint } from './../sharedcomponents/ForwardCommands/TempSetPoint';
import { HumiditySetPoint } from './../sharedcomponents/ForwardCommands/HumiditySetPoint';
import { O2SetPoint } from './../sharedcomponents/ForwardCommands/O2SetPoint';
import { CO2SetPoint } from './../sharedcomponents/ForwardCommands/CO2SetPoint';
import { ChangeReeferId } from './../sharedcomponents/ForwardCommands/ChangeReeferId';
import { ChangeReportingInterval } from './../sharedcomponents/ForwardCommands/ChangeReportingInterval';
import { ChangeDataLogInterval } from './../sharedcomponents/ForwardCommands/ChangeDataLogInterval';
import { AssignPANID } from './../sharedcomponents/ForwardCommands/AssignPANID';
import { RebootReeferController } from './../sharedcomponents/ForwardCommands/RebootReeferController';
import { VerifyModelValidity } from './../sharedcomponents/ForwardCommands/VerifyModelValidity';
import { SyncReeferClock } from './../sharedcomponents/ForwardCommands/SyncReeferClock';
import { StartDeforst } from './../sharedcomponents/ForwardCommands/StartDeforst';
import { ChangeDeforstInterval } from './../sharedcomponents/ForwardCommands/ChangeDeforstInterval';
import { TraditionalDataDownload } from './../sharedcomponents/ForwardCommands/TraditionalDataDownload';
import { StopPTI } from './../sharedcomponents/ForwardCommands/StopPTI';
import { ScheduledPreTrip } from './../sharedcomponents/ForwardCommands/ScheduledPreTrip';
import { PreTrip } from './../sharedcomponents/ForwardCommands/PreTrip';
import { LastPretripResult } from './../sharedcomponents/ForwardCommands/LastPretripResult';
import { QueryReeferInventory } from './../sharedcomponents/ForwardCommands/QueryReeferInventory';
import { UpdateModelConfiguration } from './../sharedcomponents/ForwardCommands/UpdateModelConfiguration';
import { ChangeReeferClockSyncSetting } from './../sharedcomponents/ForwardCommands/ChangeReeferClockSyncSettings';
import { GuestReeferConfiguration } from './../sharedcomponents/ForwardCommands/GuestReeferConfiguration';
import { Comments } from './../sharedcomponents/Comments';
import DetailFormatters from '../../actions/ReeferDetailFilters';
import moment from 'moment';
import Formatters from '../../actions/Formatters';
import DateFormat from 'dateformat';

var Excel = Exceljs.default;
var self;
var Config: any = require('../../Config.json');

interface ReeferDetailsState {
    reeferDetailsData: UnitDetailsUI;
    reeferHistoryData: server.UnitHistoryUI[];
    rcdHistoryData: server.RcdHistoryUI[],
    reeferCommandsData: server.CommandStatusUI[];
    reeferDetailsSearch: ReeferDetailsFilter;
    CommandTypes: server.RefCommandTypesModel[];
    ReeferId: string;
    RcdId: string;
    preTripCmd: string;
    selectedReeferData: any[];
    modelTitle: string;
    popUpHtml: any;
    isChangeDeforstInterval: boolean;
    isLoading: boolean;
    enableTab: boolean;
    DataSource: string;
    reeferFormatter: server.ReeferFormatter;
    preTripData: string;
    tabContentHtml: any;
    searchInputValue: string;
    assetMasterID: number;//WI-23781
    isOpenVia: any;
    isDevice: boolean;
    fromDateHistory: string;
    toDateHistory: string;
    fromRCDDateHistory: string;
    toRCDDateHistory: string;
    fromDateCommandHistory: string;
    toDateCommandHistory: string;
}

var tempFormat;
var timeZoneCd;
var self;
var restricted = false;
var tripWISEReport;

type ReeferStatusProps =
    UserDetailState.UserState
    & ReeferStatusState.ReeferSearchState       // ... state we've requested from the Redux store     
    & typeof ReeferStatusState.actionCreators      // ... plus action creators we've requested
    & RouteComponentProps<{}>; // ... plus incoming routing parameters

interface AssetState {
    unitDetails: server.UnitDetailsUI;
    modelTitleReport: string;
    popUpHtmlReport: any;
    PTReport: string;
    assetMasterID: number;//WI-23781
    isOpenVia: any;
    isDevice: boolean;
    TWReport: string;
}

export class CurrentStatus extends React.Component<any, AssetState>{
    constructor(props: any) {
        super(props);
        tripWISEReport = JSON.parse(sessionStorage.getItem('customerDetails')).TripWISEreport;
        this.state = {
            unitDetails: this.props.assetData, modelTitleReport: '', popUpHtmlReport: '', PTReport: this.props.preTripReport,
            isOpenVia: this.props.isOpenVia, assetMasterID: this.props.AssetMasterID, isDevice: this.props.isDevice,
            TWReport: ''
        };
    }

    componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsForReefers('154');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            DetailsMap.InitDetailsMap("reeferStatusMap");
            setTimeout(() => {
                DetailsMap.LoadDetailsMap(this.state.unitDetails.GPSLatitude, this.state.unitDetails.GPSLongitude);
            }, 1000);            
            this.formatGPSLatLong(this.state.unitDetails);
            this.updateReeferCommandsDimensions();
            window.addEventListener("resize", this.updateReeferCommandsDimensions.bind(this));
     
            if (this.state.isOpenVia === "CurrentDetails") {             
                document.getElementById("collapseOne").classList.remove("show");
                document.getElementById("collapseTwo").classList.add("show");
                document.getElementById("collapseThree").classList.remove("show");
            }
            else if (this.state.isOpenVia === "Comments") {
                
                document.getElementById("collapseOne").classList.remove("show");
                document.getElementById("collapseTwo").classList.remove("show");
                document.getElementById("collapseThree").classList.add("show");

            } else if (this.state.isOpenVia === "RcdStatus") {
                
                document.getElementById("collapseOne").classList.add("show");
                document.getElementById("collapseTwo").classList.remove("show");
                document.getElementById("collapseThree").classList.remove("show");
            }
            else if (this.state.isOpenVia === null || this.state.isOpenVia === undefined) {
               

                document.getElementById("collapseOne").classList.add("show");
                document.getElementById("collapseTwo").classList.remove("show");
                document.getElementById("collapseThree").classList.remove("show");
            }

            //this.showTabPane(this.props.isReeferOrRCD);
            Excel.draggableModalPopup(document.getElementById("contextMenuModelReport"));
            Excel.draggableModalPopup(document.getElementById("contextMenuModelReportTW"));
        }
    }

    showTabPane(isReeferOrRCD: string) {
        if (isReeferOrRCD != null && isReeferOrRCD != undefined && isReeferOrRCD != '') {
            if (isReeferOrRCD == "Reefer") {
                if ($('#detailsPane').attr('aria-expanded') == "false")
                    $('#detailsPane').click();
            }
        }
    }

    formatGPSLatLong(params: any) {
        $("#gpsLongitude").removeClass('gpslatlong');
        $("#gpsLatitude").removeClass('gpslatlong');
        if (params.GPSLatitude != 0 && params.GPSLongitude != 0 && (params.GPSLockState == null || params.GPSLockState == '' || params.GPSLockState.toUpperCase() != "LOCKED")) {
            if (params.GPSLongitude != null)
                $("#gpsLongitude").addClass('gpslatlong');

            if (params.GPSLatitude != null)
                $("#gpsLatitude").addClass('gpslatlong');
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.assetData != null && nextProps.assetData != "") {
            this.setState({
                unitDetails: nextProps.assetData,
                assetMasterID: nextProps.AssetMasterID,//WI-23781
                isDevice: nextProps.isDevice
            });       
            if (nextProps.isDevice && nextProps.isOpenVia != "Comments") {
                document.getElementById("collapseOne").classList.add("show");
                document.getElementById("collapseTwo").classList.remove("show");
                document.getElementById("collapseThree").classList.remove("show");     
            }
            else if (!nextProps.isDevice && nextProps.isOpenVia != "Comments") {            
                document.getElementById("collapseOne").classList.remove("show");
                document.getElementById("collapseTwo").classList.add("show");
                document.getElementById("collapseThree").classList.remove("show");

            }
            else if (this.state.isOpenVia === null || this.state.isOpenVia === undefined) {
                document.getElementById("collapseOne").classList.remove("show");
                document.getElementById("collapseTwo").classList.remove("show");
                document.getElementById("collapseThree").classList.add("show");
            }

            //this.showTabPane(nextProps.isReeferOrRCD);
            DetailsMap.LoadDetailsMap(nextProps.assetData.GPSLatitude, nextProps.assetData.GPSLongitude);
            this.formatGPSLatLong(nextProps.assetData);
        }

        if (nextProps.preTripReport != null && nextProps.preTripReport != "") {
            this.setState({
                PTReport: nextProps.preTripReport
            });
        }
        else {
            this.setState({ PTReport: null });
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateReeferCommandsDimensions.bind(this));
    }

    updateReeferCommandsDimensions() {
        $(".dynamicHeight").css('min-height', $(window).height() - 190);
        $(".dynamicHeight").css('max-height', $(window).height() - 190);
        $("#reeferStatusMap").css('min-height', $(window).height() - 210);
        $("#reeferStatusMap").css('max-height', $(window).height() - 210);

    }

    popUpReport() {
        if (this.state.PTReport == null || this.state.PTReport == '')
            PopupWindow.showErrorMessage("Alert", "No pre-trip reports have been collected for this reefer. Execute the ‘Get Pre-Trip Results’ command to collect the latest available report.");
        else {
            this.setState({
                modelTitleReport: 'Pre-Trip Report', popUpHtmlReport: <div dangerouslySetInnerHTML={{ __html: this.state.PTReport }} />
            });
            $('#btnTrigger').click();
        }
    }    

    downloadPTReport() {
        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
            var blob = new Blob([this.state.PTReport], {
                type: "text/plain;charset=utf-8"
            });
            window.navigator.msSaveBlob(blob, 'PT_' + this.state.unitDetails.ReeferID + '.htm');
        } else {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.state.PTReport));
            element.setAttribute('download', 'PT_' + this.state.unitDetails.ReeferID + '.htm');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }

    printPTReport() {
        var divToPrint = document.getElementById("printData");
        var newWin = window.open("");
        newWin.document.write(divToPrint.innerHTML);
        newWin.document.close();
        newWin.print();
        newWin.close();
    }


    popUpGetTWReport() {
        if (this.state.unitDetails.ReeferID != null) {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetTripWISEReport?containerID=' + this.state.unitDetails.ReeferID;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    this.setState({ TWReport: result }, () => { this.bindTWReport(); });
                });
        }
    }
    handleButtonClick() {
              if ((self.state.ReeferId !== null && self.state.ReeferId !== undefined )|| (self.state.RcdId !== null && self.state.RcdId !== undefined)) {
            const filterParams = {
                ReeferId: self.state.ReeferId,
                RcdId: self.state.RcdId,
            };
            self.GetCurrentDetails(filterParams);
        }
    }
  
    bindTWReport() {
        $('#globalLoader').hide();
        if (this.state.TWReport == null || this.state.TWReport == '')
            PopupWindow.showErrorMessage("Alert", "No TripWISE reports have been collected for this reefer. Execute the ‘Get TripWise Report’ command to collect the latest available report.");
        else {
            this.setState({ modelTitleReport: 'TripWISE Report', popUpHtmlReport: <div dangerouslySetInnerHTML={{ __html: this.state.TWReport }} /> });
            $('#btnTriggerTW').click();
        }
    }    
    downloadTWReport() {
        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
            var blob = new Blob([this.state.TWReport], {
                type: "text/plain;charset=utf-8"
            });
            window.navigator.msSaveBlob(blob, 'TripWISEReport_' + this.state.unitDetails.ReeferID + '.htm');
        } else {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.state.TWReport));
            element.setAttribute('download', 'TripWISEReport_' + this.state.unitDetails.ReeferID + '.htm');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }

    printTWReport() {
        var divToPrint = document.getElementById("printDataTW");
        var newWin = window.open("");
        newWin.document.write(divToPrint.innerHTML);
        newWin.document.close();
        newWin.print();
        newWin.close();
    }

    public render() {
        return <div>
            <div className='row'>
                <div className='col-md-4 col-lg-4'><div id="reeferStatusMap" className='pb-2'></div></div>
                <div className='col-md-8 col-lg-8 ps-0'>
                    <div className="accordion" id="accordion" role="tablist" aria-multiselectable="true">
                        <div hidden={restricted}>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Device details
                                    </button>                                   
                                    </h2>                              
                                <div id="collapseOne" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Device ID </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.RCDID}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>MCC (country) </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.CountryName}</div>
                                                <div className='col-md-3 pt-1 fw-medium'>Device Supply (V) </div>
                                                <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.ReeferACPowerLevel}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Device FW ver </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.RCDFirmwareVersion}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>MNC </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.MNC}</div>
                                                <div className='col-md-3 pt-1 fw-medium'>Device temp. {tempFormat} </div>
                                                <div className='col-md-1 px-2 pt-1'>{DetailFormatters.TemperatureFormatterForDeviceTemp(this.state.unitDetails)}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Device BL ver </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.RCDBootloaderVersion}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>LAC </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.TowerLocalizationAreaCode}</div>
                                                <div className='col-md-3 pt-1 fw-medium'>Device Bat. (V) </div>
                                                <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.BatteryVoltage}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Device Mesh FW ver </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.RCDMeshFirmwareVersion}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>Tower ID </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.TowerBaseStationID}</div>
                                                <div className='col-md-3 pt-1 fw-medium'>Reporting (min) </div>
                                                <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.RCDReportingInterval}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Latitude </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.GPSLatitudeFormatterForReefer(this.state.unitDetails)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>MSISDN </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.MSISDN}</div>
                                                <div className='col-md-3 pt-1 fw-medium'>Device Type </div>
                                                <div className='col-md-1 px-2 pt-1'>{DetailFormatters.StringFormater(this.state.unitDetails.DeviceType)}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Longitude </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.GPSLongitudeFormatterForReefer(this.state.unitDetails)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>IMSI </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.SIM_IMSI}</div>
                                                <div className='col-md-3 pt-1 fw-medium'>Device Config </div>
                                                <div className='col-md-1 px-2 pt-1'>{DetailFormatters.GuestReeferModeFormatter(this.state.unitDetails.DeviceConfig)}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'>Loc age (h:m:s) </div>
                                                <div className='col-md-2 px-2 pt-1'>{DetailFormatters.reeferSecondsToTimeConverter(this.state.unitDetails)}</div>
                                                <div className='col-md-2 pt-1 fw-medium'>ICCID </div>
                                                <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.ICCID}</div>
                                                <div className='col-md-3 pt-1 fw-medium'>Geofence Revision </div>
                                                <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.RevisionNum}</div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-2 pt-1 fw-medium'></div>
                                                <div className='col-md-2 px-2 pt-1'></div>
                                                <div className='col-md-2 pt-1 fw-medium'>Cell Signal </div>
                                                <div className='col-md-2 px-2 pt-1'>
                                                    <img className='Rssiformatter' src={DetailFormatters.RSSIFormatter(this.state.unitDetails.RSSI)}></img></div>
                                                <div className='col-md-3 pt-1 fw-medium'>PWR </div>
                                                <div className='col-md-1 px-2 pt-1 PlugSolidDetails'>
                                                    {(this.state.unitDetails.RCDPowerSourceCd != null) ?
                                                        <img className='Rssiformatter' src={DetailFormatters.pwrStateFormatter(this.state.unitDetails)}></img> : ''}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item rounded-0">
                              
                                <h2 className="accordion-header">

                                    <button id="detailsPane" className="accordion-button rounded-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-controls="collapseTwo" aria-expanded="false">
                                        Reefer details
                                        <div className="btn-group btn-group-sm aggrid-icons ms-1" role="group" aria-label="Small button group">
                                            <button type="button"
                                                id="refreshid"
                                                title="Refresh"
                                                className="btn btn-outline-secondary"
                                                onClick={this.handleButtonClick.bind(this)}> <span className='fas fa-sync-alt'></span>
                                            </button>
                                        </div>
                                    </button>
                                      
                                           
                                 
                                    </h2>
                               
                                <div id="collapseTwo" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        { 
                                            (this.state.unitDetails.ReeferID != null || this.state.unitDetails.RCDID == undefined) ?
                                                <div>
                                                    <div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>ReeferID </div>
                                                            <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.ReeferID}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Latitude </div>
                                                            <div id="gpsLatitude" className='col-md-2 px-2 pt-1'>{this.state.unitDetails.GPSLatitude}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Frequency </div>
                                                            <div className='col-md-1 px-2 pt-1'>{DetailFormatters.LineFrequencyFormatter(this.state.unitDetails.LineFrequency, this.state.unitDetails.LineFrequencyQualifier,this.state.unitDetails.ReeferOEMTypeCd,this.state.unitDetails.ControllerTypeCd )}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Event Date/Time {timeZoneCd} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.DateTypeFormatter(this.state.unitDetails.EventDTTM)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Longitude </div>
                                                            <div id="gpsLongitude" className='col-md-2 px-2 pt-1'>{this.state.unitDetails.GPSLongitude}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>FreshAirType</div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.FreshAirType}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Last Event </div>                                                
                                                            <div className='col-md-2 px-2 pt-1 ReeferDetails-ellipsis' title={this.props.reeferFormatters != null ?
                                                                DetailFormatters.EventDescriptionFormatters(this.state.unitDetails,
                                                                    this.props.reeferFormatters.CustomerSpecificEventList,
                                                                    this.props.reeferFormatters.EventMasterList) : this.props.reeferFormatters == null ? this.state.unitDetails.EventDescription : ''}>
                                                                {this.props.reeferFormatters != null ?
                                                                    DetailFormatters.EventDescriptionFormatters(this.state.unitDetails,
                                                                        this.props.reeferFormatters.CustomerSpecificEventList,
                                                                        this.props.reeferFormatters.EventMasterList) : this.props.reeferFormatters == null ? this.state.unitDetails.EventDescription : ''}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Display Serial # </div>
                                                            <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.DisplaySerNum}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Atmosphere controller Serial # </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.AtmContSerNum}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Reefer Data {timeZoneCd} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.DateTypeFormatter(this.state.unitDetails.UnitEventDTTM)}</div>

                                                            <div className='col-md-2 pt-1 fw-medium'>USDA 1 {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.USDA1Temp)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Power Measurement Serial # </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.PwrMeasureSerNum}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Alarm </div>
                                                            <div className='col-md-2 px-2 pt-1 wordbreak'>{DetailFormatters.AlarmListFormatter(this.state.unitDetails.AlarmsList)}</div>

                                                            <div className='col-md-2 pt-1 fw-medium'>USDA 2 {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.USDA2Temp)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Humidity sensor Serial # </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.HumSensorSerNum}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Device Attached </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.YesNoConverter(this.state.unitDetails.IsReeferCommunicationEstablished)}</div>

                                                            <div className='col-md-2 pt-1 fw-medium'>USDA 3 {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.USDA3Temp)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Oxygen sensor Serial # </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.O2SensorSerNum}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Run </div>
                                                            <div className='col-md-2 px-2 pt-1'>
                                                                {(this.state.unitDetails.RunState != null) ?
                                                                    <img className='Rssiformatter' src={DetailFormatters.runStateFormatter(this.state.unitDetails.RunState)}></img> : ''}
                                                            </div>

                                                            <div className='col-md-2 pt-1 fw-medium'>USDA4/Cargo {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.Cargo4Temp)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Carbon dioxide sensor Serial # </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.CO2SensorSerNum}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Opr. Mode </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.OperatingModeFormatter(this.state.unitDetails.RunningMode)}</div>

                                                            <div className='col-md-2 pt-1 fw-medium'>RH set </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.HumiditySetpointFormatter(this.state.unitDetails.HumiditySetpoint)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Frequency Converter Serial # </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.FreqConverterSerNum}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>OEM </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.OEMTypeFormatterDetail(this.state.unitDetails.ReeferOEMTypeCd)}</div>

                                                            <div className='col-md-2 pt-1 fw-medium'>CO2 Set </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.SensorDataFormatter(this.state.unitDetails.CO2Setpoint)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Reefer Name </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.OEMModelDesc}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>OEM Model </div>
                                                            <div className='col-md-2 px-2 pt-1'>{this.props.reeferFormatters != null ? DetailFormatters.UnitTypesListFormatters(this.state.unitDetails, this.props.reeferFormatters.UnitTypesList) : this.state.unitDetails.OEMModel}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>O2 Set </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.SensorDataFormatter(this.state.unitDetails.O2Setpoint)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Controller Type </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.ControllerDesc}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>SW Version </div>
                                                            <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.SoftwareRevision}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>T Rtn. 2 {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.ReturnTemp2)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Model Number </div>
                                                            <div className='col-md-1 px-2 pt-1 text-truncate' title={DetailFormatters.ModelNumberFormatter(this.state.unitDetails)}>{DetailFormatters.ModelNumberFormatter(this.state.unitDetails)}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Setpoint Temp {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.SetPoint)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>T Sup. 2 {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.SupplyTemp2)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Sync Reefer Clock </div>
                                                            <div className='col-md-1 px-2 pt-1'>{DetailFormatters.BooleanConverter(this.state.unitDetails.ReeferClockInSync)}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>T Rtn. 1 {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.ReturnTemp1)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Fresh air Ex </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.SensorDataFormatter(this.state.unitDetails.VentPositionSensorCMH)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Trip Name </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.TripName}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>T Sup. 1 {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.SupplyTemp1)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Current 3 Phases </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.Current3PhaseFormatter(this.state.unitDetails.ThreePhaseCurrent)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Trip Status </div>
                                                            <div className='col-md-1 px-2 pt-1'>{this.state.unitDetails.TripDefStatusDsc}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Ambient Temp {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.AmbientTemp)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Suction Press </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.SensorDataFormatter(this.state.unitDetails.CompositeSuctionPressure)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Booking #</div>
                                                            <div className='col-md-1 px-2 pt-1 text-truncate' title={this.state.unitDetails.BookingNumber}>{this.state.unitDetails.BookingNumber}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Fence Name </div>
                                                            <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.GeofenceName}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Suction Temp {tempFormat} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.TemperatureFormatter(this.state.unitDetails.CompressorSuctionTemp)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>BK temp {tempFormat} </div>
                                                            <div className='col-md-1 px-2 pt-1'>{DetailFormatters.TemperatureFormatterForBooking(this.state.unitDetails.TemperatureUnit)}</div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>Fence Status </div>
                                                            <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.Geofence} </div>
                                                            <div className='col-md-2 pt-1 fw-medium'>Discharge Press </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.SensorDataFormatter(this.state.unitDetails.DischargePressure)}</div>
                                                            <div className='col-md-3 pt-1 fw-medium'>Condenser Press </div>
                                                            <div className='col-md-1 px-2 pt-1'>{DetailFormatters.SensorDataFormatter(this.state.unitDetails.CondenserPressure)}</div>

                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>OEM PTI Time {timeZoneCd} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{(this.state.unitDetails.DeviceType != null && (this.state.unitDetails.DeviceType.trim() == 'CT4000' || this.state.unitDetails.DeviceType.trim() == 'TripLINK')) ? DetailFormatters.DateTypeFormatter(this.state.unitDetails.TWDateTime) : '-NA-'}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>TripWISE Report </div>
                                                            <div className='col-md-2 px-2 pt-1 px-0'>
                                                                {(tripWISEReport == true && this.state.unitDetails.DeviceType != null && (this.state.unitDetails.DeviceType.trim() == 'CT4000' || this.state.unitDetails.DeviceType.trim() == 'TripLINK')) ? <a className="anchor-text" data-bs-toggle="modal" data-bs-backdrop="static" onClick={this.popUpGetTWReport.bind(this)}>Show TripWise Results</a> : '-NA-'}
                                                            </div>
                                                            <div className='col-md-3 pt-1 fw-medium'>OEM PTI state </div>
                                                            <div className='col-md-1 px-2 pt-1'>
                                                                {(this.state.unitDetails.DeviceType != null && (this.state.unitDetails.DeviceType.trim() == 'CT4000' || this.state.unitDetails.DeviceType.trim() == 'TripLINK')) && (this.state.unitDetails.TripWiseResultDescription != null && this.state.unitDetails.TripWiseResultDescription.trim() != '-NA-' && this.state.unitDetails.TripWiseResultDescription.trim() != '') ? <img title={this.state.unitDetails.TripWiseResultDescription.trim()} width="15px" height="15px" className='Rssiformatter' src={DetailFormatters.tripWISEStatusFormatter(this.state.unitDetails.TripWiseResultDescription)}></img> : '-NA-'}
                                                            </div>
                                                        </div>  
                                                        <div className='row'>
                                                        <div className='col-md-2 pt-1 fw-medium'>PTI Time {timeZoneCd} </div>
                                                            <div className='col-md-2 px-2 pt-1'>{DetailFormatters.DateTypeFormatter(this.state.unitDetails.PTRDateTime)}</div>
                                                            <div className='col-md-2 pt-1 fw-medium'>PTI Report </div>
                                                            <div className='col-md-2 px-2 pt-1 px-0'>
                                                                {(this.state.unitDetails.ReeferOEMTypeCd != null && (this.state.unitDetails.ReeferOEMTypeCd.trim() != 'T' || (this.state.unitDetails.OEMModel == 'MP3000A' || this.state.unitDetails.OEMModel == 'MP3000'))) ? <a className="anchor-text" data-bs-toggle="modal" data-bs-backdrop="static" onClick={this.popUpReport.bind(this)}>Show Pre-Trip Results</a> : '-NA-'}
                                                            </div>
                                                            <div className='col-md-3 pt-1 fw-medium'>PTI Result </div>
                                                            <div className='col-md-1 px-2 pt-1'>
                                                                {(this.state.unitDetails.PTResult != null && this.state.unitDetails.PTResult.trim() != '-NA-' && this.state.unitDetails.PTResult.trim() != '') ? <img title={this.state.unitDetails.PTResult.trim() == "OK" ? "Passed" : this.state.unitDetails.PTResult.trim() == "NG" ? "Failed" : this.state.unitDetails.PTResult.trim()} className='Rssiformatter' src={DetailFormatters.preTripFormatter(this.state.unitDetails.PTResult)}></img> : '-NA-'}
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-2 pt-1 fw-medium'>PTI Type </div>
                                                            <div className='col-md-2 px-2 pt-1'>{this.state.unitDetails.PTIType}</div>
                                                        </div>                                             
                                                    </div>
                                                </div> : <div className='alert alert-info'> No association exist </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='alert alert-info' hidden={!restricted}>Current Details not available</div>
                        <div id="collapseThree">
                            <div><Comments reeferData={this.state.unitDetails} AssetMasterID={this.state.assetMasterID} ></Comments></div>
                        </div>
                        <div className="modal fade" id="contextMenuModelReport" role="dialog">
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header" id="contextMenuModelHeader">
                                        <h5 className="modal-title">{this.state.modelTitleReport}</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                                       
                                    </div>
                                    <div className="modal-body ptr-report pb-3">
                                        <div className='aggrid-icons-bg'>
                                            <div className="btn-group aggrid-icons">
                                                <button type="button" id="hidePopUpBtn" title='Download' className="btn btn-outline-secondary" onClick={this.downloadPTReport.bind(this)}><span className='fa fa-download'></span></button>
                                                <button type="button" id="hidePopUpBtn" title='Print' className="btn btn-outline-secondary" onClick={this.printPTReport.bind(this)}><span className='fa fa-print'></span></button>
                                            </div>
                                        </div>
                                        {this.state.popUpHtmlReport}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button id="btnTrigger" data-bs-toggle="modal" className='d-none' data-bs-target="#contextMenuModelReport" />
                        <div className='d-none' id="printData"><div dangerouslySetInnerHTML={{ __html: this.state.PTReport }} /></div>

                        <div className="modal fade" id="contextMenuModelReportTW" role="dialog">
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header" id="contextMenuModelHeader">
                                        <h5 className="modal-title">{this.state.modelTitleReport}</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                                       
                                    </div>
                                    <div className="modal-body ptr-report ptr-report-table">
                                        <div className='aggrid-icons-bg'>
                                            <div className="btn-group aggrid-icons">
                                                <button type="button" id="hidePopUpBtn" title='Download' className="btn btn-outline-secondary" onClick={this.downloadTWReport.bind(this)}><span className='fa fa-download'></span></button>
                                                <button type="button" id="hidePopUpBtn" title='Print' className="btn btn-outline-secondary" onClick={this.printTWReport.bind(this)}><span className='fa fa-print'></span></button>
                                            </div>
                                        </div>
                                        {this.state.popUpHtmlReport}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button id="btnTriggerTW" data-bs-toggle="modal" className='d-none' data-bs-target="#contextMenuModelReportTW" />
                        <div className='d-none' id="printDataTW"><div dangerouslySetInnerHTML={{ __html: this.state.TWReport }} /></div>
                    </div>
                </div>
            </div>
        </div>
    }
}

class ReeferDetails extends React.Component<ReeferStatusProps, ReeferDetailsState> {
    constructor(props: any) {
        super(props);
        self = this;
        var filterSet = new ReeferDetailsFilter();
        var reeferId = null;
        var rcdId = null;
        var isOpenVia = null;
        var isDevice = false;        
        if (this.props.location.state != null && this.props.location.state != undefined) {
            var params = this.props.location.state.reeferData;
            var dataSource = this.props.location.state.source;
            var formattersData = this.props.location.state.reeferFormatter;
            isOpenVia = this.props.location.state.isOpenVia;
            if (this.props.location.state.isDevice != null && this.props.location.state.isDevice != undefined)
                isDevice = this.props.location.state.isDevice;
            else
                isDevice = false;

            if (params != null && params != undefined) {
                if (dataSource == "Device")
                    rcdId = params.RCDID;
                else {
                    reeferId = params.ReeferID;
                    rcdId = params.RCDID;
                }
            }
        }

        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var toDTTM = Formatters.DateTimeFormatter(currentUtcDttm)
        var modifiedDttm = new Date(toDTTM);
        modifiedDttm.setDate(modifiedDttm.getDate() - 1);
        var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');

        var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
        var toDate = moment(new Date(toDTTM)).endOf('day').toString();

        var fromCommandDate = moment(new Date(toDate)).startOf('day').toString();
        var toCommandDate = moment(new Date(toDate)).endOf('day').toString();

        this.state = {
            reeferDetailsData: new UnitDetailsUI(), reeferHistoryData: [], rcdHistoryData: [], reeferCommandsData: [], reeferDetailsSearch: filterSet, CommandTypes: [], ReeferId: reeferId,
            RcdId: rcdId, preTripCmd: null, selectedReeferData: [], modelTitle: '', popUpHtml: '', isChangeDeforstInterval: false, isLoading: true, enableTab: false, DataSource: dataSource,
            reeferFormatter: formattersData, preTripData: null, tabContentHtml: '', searchInputValue: '', assetMasterID: 0, isOpenVia: isOpenVia, isDevice: isDevice
            , fromDateHistory: DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM')
            , toDateHistory: DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM')
            , fromDateCommandHistory: DateFormat(new Date(fromCommandDate), 'mm/dd/yyyy HH:MM')
            , toDateCommandHistory: DateFormat(new Date(toCommandDate), 'mm/dd/yyyy HH:MM')
            , fromRCDDateHistory: DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM')
            , toRCDDateHistory: DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM')
        };
        //$('#globalLoader').show();
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/GetCommandTypes')
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json() as Promise<server.RefCommandTypesModel[]>)
        //    .then(data => {
        //        //$('#globalLoader').hide();
        //        this.setState({ CommandTypes: data }, () => {
        //            $('#globalLoader').show();

        if (params != null) {
            if (params.ReeferID != null) {
                var url = Config.ApiBaseUrl + '/api/reeferstatus/GetPTRReport?containerID=' + params.ReeferID;
                var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<string>)
                    .then(data => {
                        $('#globalLoader').show();
                        this.setState({
                            preTripData: data,
                        }, () => this.GetReeferDetailsSearchData(params));
                        //$('#globalLoader').hide();
                    });
            }
            else
                this.GetReeferDetailsSearchData(params);
        }
        else
            this.GetReeferDetailsSearchData(params)

        //        });
        //});

        tempFormat = DetailFormatters.GetTempColumnFormatter();
        timeZoneCd = DetailFormatters.GetTimeZoneFormatter();
        restricted = false;
    }

    updateReeferCommandsDimensions() {
        $(".dynamicHeight").css('min-height', $(window).height() - 160);
        $(".dynamicHeight").css('max-height', $(window).height() - 160);
    }

    GetSelectedReeferData() {
        $('#globalLoader').show();
        var reeferSearchFilters: server.ReeferSearchFilters = {
            SelectedOem: '', SelectedCountry: '', SelectedReefer: this.state.ReeferId, SelectedGeofence: '', SelectedInterval: '', SelectedGeofenceInside: '', SelectedVesselCode: '', StatusFilters: [], AllReefers: '',
            CustomAttributeFilters: null, SelectedAssetTypes: '', SelectedAssetStates: '', SelectedBookingNumber: '', SelectedVesselCD: '', SelectedCall: '',
            SelectedVoyage: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: []//WI-26881
            }; 
        var childRequest = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusDataSP', { method: 'POST', body: JSON.stringify(reeferSearchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(childRequest)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(childData => {
                $('#globalLoader').hide();
                if (childData != null && childData != undefined && childData.length > 0) {
                    var reeferData = [];
                    reeferData.push(childData[0]);
                    this.setState({
                        selectedReeferData: reeferData,
                        isLoading: false
                    }, () => this.ShowFirstTab());
                }
                else {
                    this.ShowFirstTab();
                }
            });
    }

    ShowFirstTab() {
        $('.nav-underline button:first').click();
        this.setState({ tabContentHtml: this.renderTabContentHtml(1) });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateReeferCommandsDimensions.bind(this));
    }

    componentDidMount() {
        this.ShowFirstTab();
        if (this.state.ReeferId == null && this.state.RcdId == null)
            this.setState({ isLoading: false });
        else {
            if (this.state.ReeferId != null && this.state.ReeferId != undefined && this.state.ReeferId != '' && this.state.DataSource == "Reefer") {
                this.setState({ searchInputValue: this.state.ReeferId });
            }
            else if (this.state.RcdId != null && this.state.RcdId != undefined && this.state.RcdId != '' && this.state.DataSource == "Device") {
                this.setState({ searchInputValue: this.state.RcdId });
            }
            else {
                if (this.state.ReeferId != null && this.state.ReeferId != undefined && this.state.ReeferId != '') {
                    this.setState({ searchInputValue: this.state.ReeferId });
                }
                else if (this.state.RcdId != null && this.state.RcdId != undefined && this.state.RcdId != '') {
                    this.setState({ searchInputValue: this.state.RcdId });
                }
            }
        }

        this.updateReeferCommandsDimensions();
        window.addEventListener("resize", this.updateReeferCommandsDimensions.bind(this));
        Excel.draggableModalPopup(document.getElementById("contextMenuModel"));
        $('#Command').hide();

        //$('.nav-tabs a').on('shown.bs.tab', function (event) {
        $(".nav-underline button").click(function (event) {
            var targetId = event.target.id;
            if (targetId == 'lnkCurrentStatus') {
                self.renderTabContent(1);
            }
            else if (targetId == 'lnkHistory') {
                self.renderTabContent(2);
            }
            else {
                self.renderTabContent(3);
            }
        });
    }

    renderTabContent(tabNumber: number) {
        this.setState({ tabContentHtml: this.renderTabContentHtml(tabNumber) });
    }

    renderTabContentHtml(tabNumber: number) {
        if (tabNumber == 1) {
            return <div className="tab-pane fade show active dynamicHeight" id="asset">
                <CurrentStatus assetData={this.state.reeferDetailsData} reeferFormatters={this.state.reeferFormatter} preTripReport={this.state.preTripData} 
                    isReeferOrRCD={this.state.DataSource} AssetMasterID={this.state.assetMasterID} isOpenVia={this.state.isOpenVia}
                    isDevice={this.state.isDevice}></CurrentStatus>
            </div>;
        }
        else if (tabNumber == 2) {
            if (this.state.ReeferId != null && this.state.ReeferId != "") {
                return <div className="tab-pane fade show active dynamicHeight" id="history">
                    <div><ReeferDetailsHistory stateData={this.state} IsReefer={true}
                        FromDate={this.state.fromDateHistory} ToDate={this.state.toDateHistory}
                        HoldHistoryDates={this.HoldHistoryDates.bind(this)}
                        HoldHistoryData={this.HoldHistoryData.bind(this)}
                    ></ReeferDetailsHistory></div>
                </div>;
            }
            else {
                return <div className="tab-pane fade show active dynamicHeight" id="history">
                    <div><ReeferDetailsHistory stateData={this.state} IsReefer={false}
                        FromDateRCD={this.state.fromRCDDateHistory} ToDateRCD={this.state.toRCDDateHistory}
                        HoldRCDHistoryDates={this.HoldRCDHistoryDates.bind(this)}
                        HoldHistoryData={this.HoldHistoryData.bind(this)}
                    ></ReeferDetailsHistory></div>
                </div>;
            }
        }
        else {
            return <div className="tab-pane fade show active dynamicHeight" id="commands">
                <div><ReeferDetailsCommandStatus stateData={this.state}
                    FromDate={this.state.fromDateCommandHistory} ToDate={this.state.toDateCommandHistory}
                    HoldCommandHistoryDates={this.HoldCommandHistoryDates.bind(this)}
                    HoldCommandHistoryData={this.HoldCommandHistoryData.bind(this)}
                ></ReeferDetailsCommandStatus></div>
            </div>
        }
    }

    HoldHistoryDates(fromDate: Date, toDate: Date) {
        if (fromDate === null && toDate != null) {
            this.setState({ toDateHistory: toDate.toString() });
        }
        if (fromDate != null && toDate === null) {
            this.setState({ fromDateHistory: fromDate.toString() });
        }
    }
    HoldRCDHistoryDates(fromDate: Date, toDate: Date) {
        if (fromDate === null && toDate != null) {
            this.setState({ toRCDDateHistory: toDate.toString() });
        }
        if (fromDate != null && toDate === null) {
            this.setState({ fromRCDDateHistory: fromDate.toString() });
        }
    }

    HoldCommandHistoryDates(fromDate: Date, toDate: Date) {
        if (fromDate === null && toDate != null) {
            this.setState({ toDateCommandHistory: toDate.toString() });
        }
        if (fromDate != null && toDate === null) {
            this.setState({ fromDateCommandHistory: fromDate.toString() });
        }
    }

    HoldHistoryData(reeferFormatter: server.ReeferFormatter, reeferHistoryData: server.UnitHistoryUI[],
        rcdHistoryData: server.RcdHistoryUI[]) {

        this.setState({
            reeferHistoryData: reeferHistoryData,
            reeferFormatter: reeferFormatter,
            rcdHistoryData: rcdHistoryData
        });
    }

    HoldCommandHistoryData(reeferCommandsData: server.CommandStatusUI[]) {

        this.setState({
            reeferCommandsData: reeferCommandsData
        });
    }

    Reeferchange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value.trim();
        var inputValue = Value;

        self.setState({
            searchInputValue: inputValue
        });
    }

    GetReeferDetailsSearchData(params: any) {
        var filterSet = new ReeferDetailsFilter();

        if (this.state.DataSource == null || this.state.DataSource == undefined) {
            if (this.state.ReeferId == null) {
                filterSet.ReeferId = this.state.ReeferId;
                filterSet.RcdId = this.state.RcdId;
            }
            else if (this.state.ReeferId.length <= 11) {
                filterSet.ReeferId = this.state.ReeferId;
            }
            else if (this.state.ReeferId.length > 11) {
                filterSet.RcdId = this.state.ReeferId;
            }
        }
        else {
            filterSet.ReeferId = this.state.ReeferId;
            filterSet.RcdId = this.state.RcdId;
        }

        if (this.state.ReeferId != null || this.state.RcdId != null) {
            $('#globalLoader').show();
            this.setState({ reeferDetailsSearch: filterSet });
            var filterParams = JSON.stringify(filterSet);

            if (params != null) {
                restricted = false;
                if (this.state.isOpenVia === "RcdStatus") {
                    this.GetCurrentDetails(filterParams);
                }
                else {
                    this.setState({
                        //reeferDetailsData: params,
                        assetMasterID: params.AssetMasterID,//WI-23781
                        //isLoading: false
                    }, () => this.GetCurrentDetails(filterParams));//RCNG-65
                    //$('#globalLoader').hide();
                }
            }
            else {
                this.GetCurrentDetails(filterParams);
            }

        }
        else
            $('#globalLoader').hide();
    }   

    private GetCurrentDetails(filterParams: string) {
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json() as Promise<server.ReeferFormatter>)
        //    .then(data => {
        //        $('#globalLoader').hide();
        //        this.setState({
        //            reeferFormatter: data
        //        }, () => {
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ReeferCurrentDetailsDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.ReeferDetails>)
            .then(data => {
                $('#globalLoader').hide();
                if (data.UnitDetails.RCDID != null) {
                    if ((data.UnitDetails.IsValid3P == true && data.UnitDetails.AggRestricted == false) || (data.UnitDetails.IsValid3P == true && data.UnitDetails.AggRestricted == true && data.UnitDetails.AggApplied == true)) {
                        restricted = false;
                        this.setState({
                            reeferDetailsData: data.UnitDetails,
                            preTripData: data.PreTripReport,
                            assetMasterID: data.AssetMasterID
                        }, () => this.ShowFirstTab());
                    }
                    else {
                        restricted = true;
                        var unitDetails = new UnitDetailsUI();
                        unitDetails.UnitMasterID = data.UnitDetails.UnitMasterID;
                        unitDetails.ReeferID = data.UnitDetails.ReeferID;
                        unitDetails.RCDID = data.UnitDetails.RCDID;
                        unitDetails.RCDMasterID = data.UnitDetails.RCDMasterID;
                        this.setState({
                            reeferDetailsData: unitDetails,
                            preTripData: data.PreTripReport,
                            assetMasterID: data.AssetMasterID
                        }, () => this.ShowFirstTab());
                        //PopupWindow.showErrorMessage("Error", "Current Details not avaialble");
                    }
                }
                else {
                    restricted = false;
                    this.ClearReeferDetails();
                    this.setState({ ReeferId: this.state.reeferDetailsData.ReeferID, isLoading: false, assetMasterID: 0 }, () => this.ShowFirstTab());
                    PopupWindow.showErrorMessage("Error", "Invalid Reefer/Device");
                    return;
                }
            });
        //    });
        //});
    }

    ClearReeferDetails() {
        this.setState({
            reeferDetailsData: new UnitDetailsUI(),
            reeferHistoryData: [],
            reeferCommandsData: [],
            rcdHistoryData: [],
            preTripData: null
        });
    }

    ApplySearch() {
        const IsMatch = /^[a-zA-Z]{4}[0-9]{6,7}$/;
        if (this.state.ReeferId != null && this.state.ReeferId != undefined && this.state.ReeferId != '') {
            if (this.state.ReeferId.length <= 11) {
                if (!IsMatch.test(this.state.ReeferId)) {
                    PopupWindow.showErrorMessage("Error", "Please enter Reefer ID in proper format"); return;
                }
                else {
                    this.setState({ isLoading: true, enableTab: false });
                    self.GetReeferDetailsSearchData(null);
                }
            }
        }
        else if (this.state.RcdId != null && this.state.RcdId != undefined && this.state.RcdId != '') {
            if (this.state.RcdId.length > 11) {
                this.setState({ isLoading: true, enableTab: false });
                self.GetReeferDetailsSearchData(null);
            }
        }
    }

    ApplyReeferDetailsSearch() {
        if (this.state.searchInputValue != null && this.state.searchInputValue != undefined && this.state.searchInputValue != '') {
            var inputLength = this.state.searchInputValue.length;
            if (inputLength > 11) {
                this.setState({ RcdId: this.state.searchInputValue, ReeferId: null, isDevice: true, isOpenVia: null }, () => this.ApplySearch())
            }
            else if (inputLength <= 11) {
                this.setState({ ReeferId: this.state.searchInputValue, RcdId: null, isDevice: false, isOpenVia: null }, () => this.ApplySearch())
            }
        }
        else {
            PopupWindow.showErrorMessage("Error", "Please enter Reefer/Device ID"); return;
        }


    }

    static refreshReeferDetailsData() {
        self.setState({ isLoading: true, enableTab: true });
        self.GetReeferDetailsSearchData(null);
    }

    popUpPing() {
        self.setState({ modelTitle: 'Ping', popUpHtml: self.RenderContextMenuPopUp('Ping') });
    }

    commandDropdown() {
        if (self.props.loggedInUserData != null) {
            sessionStorage.setItem("userRights", JSON.stringify(self.props.loggedInUserData.User.Customer.Rights));
        }
        var rights = JSON.parse(sessionStorage.getItem('userRights'));
        var mapRequiresRight = [14];
        var m = $.inArray(mapRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liMapRequiresRight').addClass('disabled');
        }
        var detailsRequiresRight = [34];
        var m = $.inArray(detailsRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liDetailsRequiresRight').addClass('disabled');
        }
        var historyRequiresRight = [15];
        var m = $.inArray(historyRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liHistoryRequiresRight').addClass('disabled');
        }
        var commandstatusRequiresRight = [3];
        var m = $.inArray(commandstatusRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liCommandStatusRequiresRight').addClass('disabled');
        }
        var assignvslRequiresRight = [74];
        var m = $.inArray(assignvslRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liAssignVSLRequiresRight').addClass('disabled');
        }
        var unassignvslRequiresRight = [75];
        var m = $.inArray(unassignvslRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liUnassignVSLRequiresRight').addClass('disabled');
        }
        var assignccRequiresRight = [76];
        var m = $.inArray(assignccRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liAssignCCRequiresRight').addClass('disabled');
        }
        var unassignccRequiresRight = [77];
        var m = $.inArray(unassignccRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liUnassignCCRequiresRight').addClass('disabled');
        }
        var pingRequiresRight = [26];
        var m = $.inArray(pingRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liPingRequiresRight').addClass('disabled');
        }
        var setpointRequiresRight = [23];
        var m = $.inArray(setpointRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liSetpointRequiresRight').addClass('disabled');
        }
        var humidityRequiresRight = [27];
        var m = $.inArray(humidityRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liHumidityRequiresRight').addClass('disabled');
        }
        var o2setpointRequiresRight = [24];
        var m = $.inArray(o2setpointRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liO2SetPointRequiresRight').addClass('disabled');
        }
        var co2setpointRequiresRight = [25];
        var m = $.inArray(co2setpointRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liCO2SetPointRequiresRight').addClass('disabled');
        }
        var traditionaldownloadRequiresRight = [31];
        var m = $.inArray(traditionaldownloadRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liTraditionalDownloadRequiresRight').addClass('disabled');
        }
        var fullpretripRequiresRight = [18];
        var m = $.inArray(fullpretripRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liFullPreTripRequiresRight').addClass('disabled');
        }
        var StartPretripshortRequiresRight = [19];
        var m = $.inArray(StartPretripshortRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liStartPreTripShortRequiresRight').addClass('disabled');
        }
        var startpretripftRequiresRight = [20];
        var m = $.inArray(startpretripftRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liStartPreTripFtRequiresRight').addClass('disabled');
        }
        var stoppretripRequiresRight = [21];
        var m = $.inArray(stoppretripRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liStopPreTripRequiresRight').addClass('disabled');
        }
        var panIDRequiresRight = [109];
        var m = $.inArray(panIDRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liassignpanidRequiresRight').addClass('disabled');
        }
        var scheduledpretripRequiresRight = [106];
        var m = $.inArray(scheduledpretripRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liScheduledPreTripRequiresRight').addClass('disabled');
        }
        var lastpretripresultRequiresRight = [30];
        var m = $.inArray(lastpretripresultRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liLastPreTripResultRequiresRight').addClass('disabled');
        }
        var rebootreefercontrollerRequiresRight = [22];
        var m = $.inArray(rebootreefercontrollerRequiresRight.toString(), rights);
        if (m == -1) {
            $('#lirebootreefercontrollerRequiresRight').addClass('disabled');
        }
        var updatedatalogRequiresRight = [29];
        var m = $.inArray(updatedatalogRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liUpdateDatalogRequiresRight').addClass('disabled');
        }
        var updatecontainerIDRequiresRight = [28];
        var m = $.inArray(updatecontainerIDRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liUpdateContainerIdRequiresRight').addClass('disabled');
        }
        var uploadfirmwareRequiresRight = [33];
        var m = $.inArray(uploadfirmwareRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liUploadFirmwareRequiresRight').addClass('disabled');
        }
        var reportingintervalRequiresRight = [81];
        var m = $.inArray(reportingintervalRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liReportingIntervalRequiresRight').addClass('disabled');
        }
        var updatemodelconfigurationRequiresRight = [89];
        var m = $.inArray(updatemodelconfigurationRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liUpdateModelConfigurationRequiresRight').addClass('disabled');
        }
        var verifymodelvalidityRequiresRight = [90];
        var m = $.inArray(verifymodelvalidityRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liVerifyModelValidityRequiresRight').addClass('disabled');
        }
        var syncreeferclockRequiresRight = [92];
        var m = $.inArray(syncreeferclockRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liSyncReeferClockRequiresRight').addClass('disabled');
        }
        var changereeferclocksettingRequiresRight = [108];
        var m = $.inArray(changereeferclocksettingRequiresRight.toString(), rights);
        if (m == -1) {
            $('#lichangereeferclocksettingRequiresRight').addClass('disabled');
        }

        var startdefrostRequiresRight = [103];
        var m = $.inArray(startdefrostRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liStartDefrostRequiresRight').addClass('disabled');
        }
        var changedefrostintervalRequiresRight = [104];
        var m = $.inArray(changedefrostintervalRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
        }
        var createtripRequiresRight = [95];
        var m = $.inArray(createtripRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liCreateTripRequiresRight').addClass('disabled');
        }
        var tripstatusRequiresRight = [94];
        var m = $.inArray(tripstatusRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liTripStatusRequiresRight').addClass('disabled');
        }
        var cleardeviationRequiresRight = [98];
        var m = $.inArray(cleardeviationRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liClearDeviationRequiresRight').addClass('disabled');
        }
        var assignBookingRequiresRight = [100];
        var m = $.inArray(assignBookingRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liAssignBookingRequiresRight').addClass('disabled');
        }
        var unassignbookingRequiresRight = [101];
        var m = $.inArray(unassignbookingRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liUnassignBookingRequiresRight').addClass('disabled');
        }
        var editbookingRequiresRight = [102];
        var m = $.inArray(editbookingRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liEditBookingRequiresRight').addClass('disabled');
        }
        var assigntocustomerRequiresRight = [40];
        var m = $.inArray(assigntocustomerRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liAssignToCustomerRequiresRight').addClass('disabled');
        }
        var unassignfromcustomerRequiresRight = [82];
        var m = $.inArray(unassignfromcustomerRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liUnassignFromCustomerRequiresRight').addClass('disabled');
        }
        var controllerRequiresRight = [47];
        var m = $.inArray(controllerRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liControllerRequiresRight').addClass('disabled');
        }
        var liassignGuestreeferRequiresRight = [112, 113, 114, 115, 116];
        var m = $.inArray(liassignGuestreeferRequiresRight.toString(), rights);
        if (m == -1) {
            $('#liassignGuestreeferRequiresRight').addClass('disabled');
        }
        var vesseltasksRequiresRight = [74, 75];
        var vesseltasks = false;
        $.each(vesseltasksRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                vesseltasks = true;
            }
        });
        if (!vesseltasks) {
            $('#liVesselTasksRequiresRight').addClass('disabled');
        }
        var cargocaretasksRequiresRight = [76, 77];
        var cargocaretasks = false;
        $.each(cargocaretasksRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                cargocaretasks = true;
            }
        });
        if (!cargocaretasks) {
            $('#liCargoCareTasksRequiresRight').addClass('disabled');
        }
        var commandsRequiresRight = [18, 19, 20, 21, 22, 23, 26, 27, 24, 25, 28, 29, 30, 31, 32, 33, 83];
        var commands = false;
        $.each(commandsRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                commands = true;
            }
        });
        if (!commands) {
            $('#licommandsRequiresRight').addClass('disabled');
        }
        var managerealtimedlsettingsRequiresRight = [32, 80];
        var managerealtimedl = false;
        $.each(managerealtimedlsettingsRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                managerealtimedl = true;
            }
        });
        if (!managerealtimedl) {
            $('#liManagerealTimedSettingsRequiresRight').addClass('disabled');
        }
        var pretripRequiresRight = [18, 19, 20];
        var pretrip = false;
        $.each(pretripRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                pretrip = true;
            }
        });
        if (!pretrip) {
            $('#liPreTripRequiresRight').addClass('disabled');
        }
        var queryreeferinventoryRequiresRight = [83, 84, 85];
        var queryreeferinventory = false;
        $.each(queryreeferinventoryRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                queryreeferinventory = true;
            }
        });
        if (!queryreeferinventory) {
            $('#liQueryReeferInventoryRequiresRight').addClass('disabled');
        }
        var defrostRequiresRight = [103, 104];
        var defrost = false;
        $.each(defrostRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                defrost = true;
            }
        });
        if (!defrost) {
            $('#liDefrostRequiresRight').removeClass('enabled');
            $('#liDefrostRequiresRight').addClass('disabled');
        }
        else {
            $('#liDefrostRequiresRight').removeClass('disabled');
            $('#liDefrostRequiresRight').addClass('enabled');
        }
        var tripRequiresRight = [94, 95, 98];
        var trip = false;
        $.each(tripRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                trip = true;
            }
        });
        if (!trip) {
            $('#liTripRequiresRight').addClass('disabled');
        }
        var bookingRequiresRight = [100, 101, 102];
        var booking = false;
        $.each(bookingRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                booking = true;

            }
        });
        if (!booking) {
            $('#liBookingRequiresRight').addClass('disabled');
        }
        var thirdpartyaccessRequiresRight = [40, 82];
        var thirdpartyaccess = false;
        $.each(thirdpartyaccessRequiresRight, function (i, j) {
            var m = $.inArray(j.toString(), rights);
            if (m != -1) {
                thirdpartyaccess = true;
            }
        });
        if (!thirdpartyaccess) {
            $('#liThirdPartyAccessRequiresRight').addClass('disabled');
        }

        var dflag = self.state.selectedReeferData[0].DeviationFlg;
        var csflag = self.state.selectedReeferData[0].ControllerSerialNumberChgFlag;
        var isAssignCargo = self.state.selectedReeferData[0].IsCargoCare;
        var liassignvslRequiresRight = self.state.selectedReeferData[0].IsOnVessel;
        var ReeferOEMTypeCd = self.state.selectedReeferData[0].ReeferOEMTypeCd;

        if (ReeferOEMTypeCd.trim() == 'U') {
            $('#liDefrostRequiresRight').removeClass('enabled');
            $('#liDefrostRequiresRight').addClass('disabled');
            $('#liPreTripRequiresRight').removeClass('enabled');
            $('#liPreTripRequiresRight').addClass('disabled');
            $('#liStopPreTripRequiresRight').removeClass('enabled');
            $('#liStopPreTripRequiresRight').addClass('disabled');
        } else {
            $('#liPreTripRequiresRight').removeClass('disabled');
            $('#liPreTripRequiresRight').addClass('enabled');
            $('#liStopPreTripRequiresRight').removeClass('disabled');
            $('#liStopPreTripRequiresRight').addClass('enabled');
            $('#liDefrostRequiresRight').removeClass('disabled');
            $('#liDefrostRequiresRight').addClass('enabled');
        }
        if (ReeferOEMTypeCd.trim() == 'TR') {
            $('#liVerifyModelValidityRequiresRight').removeClass('enabled');
            $('#liVerifyModelValidityRequiresRight').addClass('disabled');
        }
        else {
            $('#liVerifyModelValidityRequiresRight').removeClass('disabled');
            $('#liVerifyModelValidityRequiresRight').addClass('enabled');
        }

        if (ReeferOEMTypeCd.trim() == 'S') {
            $('#liChangeDefrostIntervalRequiresRight').removeClass('enabled');
            $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
        }
        else {
            $('#liChangeDefrostIntervalRequiresRight').removeClass('disabled');
            $('#liChangeDefrostIntervalRequiresRight').addClass('enabled');
        }
        if (ReeferOEMTypeCd.trim() == 'C') {
            $('#liChangeDefrostIntervalRequiresRight').removeClass('enabled');
            $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
        }
        else {
            $('#liChangeDefrostIntervalRequiresRight').removeClass('disabled');
            $('#liChangeDefrostIntervalRequiresRight').addClass('enabled');
        }
        if (ReeferOEMTypeCd.trim() == 'D') {
            $('#liDefrostRequiresRight').removeClass('enabled');
            $('#liDefrostRequiresRight').addClass('disabled');
            $('#liChangeDefrostIntervalRequiresRight').removeClass('enabled');
            $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
        }
        else {
            $('#liDefrostRequiresRight').removeClass('disabled');
            $('#liDefrostRequiresRight').addClass('enabled');
            $('#liChangeDefrostIntervalRequiresRight').removeClass('disabled');
            $('#liChangeDefrostIntervalRequiresRight').addClass('enabled');
        }
        if (ReeferOEMTypeCd.trim() == 'T') {
            $('#liChangeDefrostIntervalRequiresRight').removeClass('enabled');
            $('#liChangeDefrostIntervalRequiresRight').addClass('disabled');
        }
        else {
            $('#liChangeDefrostIntervalRequiresRight').removeClass('disabled');
            $('#liChangeDefrostIntervalRequiresRight').addClass('enabled');
        }

        if (self.state.selectedReeferData[0].BookingNumber != null) {
            $('#liUnassignBookingRequiresRight').removeClass('disabled');
            $('#liUnassignBookingRequiresRight').addClass('enabled');
            $('#liEditBookingRequiresRight').removeClass('disabled');
            $('#liEditBookingRequiresRight').addClass('enabled');
            if (self.state.selectedReeferData[0].EventMasterID == self.state.selectedReeferData[0].LastBookingEventMasterId) {
                $('#liAssignBookingRequiresRight').removeClass('disabled');
                $('#liAssignBookingRequiresRight').addClass('enabled');
                $('#liUnassignBookingRequiresRight').removeClass('enabled');
                $('#liUnassignBookingRequiresRight').addClass('disabled');
                $('#liEditBookingRequiresRight').removeClass('enabled');
                $('#liEditBookingRequiresRight').addClass('disabled');
            } else {
                $('#liAssignBookingRequiresRight').removeClass('enabled');
                $('#liAssignBookingRequiresRight').addClass('disabled');
                $('#liUnassignBookingRequiresRight').removeClass('disabled');
                $('#liUnassignBookingRequiresRight').addClass('enabled');
                $('#liEditBookingRequiresRight').removeClass('disabled');
                $('#liEditBookingRequiresRight').addClass('enabled');
            }
        }
        else {
            $('#liUnassignBookingRequiresRight').removeClass('enabled');
            $('#liUnassignBookingRequiresRight').addClass('disabled');
            $('#liEditBookingRequiresRight').removeClass('enabled');
            $('#liEditBookingRequiresRight').addClass('disabled');
            $('#liAssignBookingRequiresRight').removeClass('disabled');
            $('#liAssignBookingRequiresRight').addClass('enabled');
        }

        if (!liassignvslRequiresRight) {
            $('#liAssignVSLRequiresRight').removeClass('disabled');
            $('#liAssignVSLRequiresRight').addClass('enabled');
            $('#liUnassignVSLRequiresRight').removeClass('enabled');
            $('#liUnassignVSLRequiresRight').addClass('disabled');
        } else {
            $('#liAssignVSLRequiresRight').removeClass('enabled');
            $('#liAssignVSLRequiresRight').addClass('disabled');
            $('#liUnassignVSLRequiresRight').removeClass('disabled');
            $('#liUnassignVSLRequiresRight').addClass('enabled');
        }

        if (isAssignCargo) {
            $('#liUnassignCCRequiresRight').removeClass('disabled');
            $('#liUnassignCCRequiresRight').addClass('enabled');
            $('#liAssignCCRequiresRight').removeClass('enabled');
            $('#liAssignCCRequiresRight').addClass('disabled');
        }
        else {
            $('#liUnassignCCRequiresRight').removeClass('enabled');
            $('#liUnassignCCRequiresRight').addClass('disabled');
            $('#liAssignCCRequiresRight').removeClass('disabled');
            $('#liAssignCCRequiresRight').addClass('enabled');
        }

        if (csflag) {
            $('#liControllerRequiresRight').removeClass('disabled');
            $('#liControllerRequiresRight').addClass('enabled');
        } else {
            $('#liControllerRequiresRight').removeClass('enabled');
            $('#liControllerRequiresRight').addClass('disabled');
        }

        if (self.state.selectedReeferData[0].TripStatusCd != null) {
            if (dflag) {
                $('#liClearDeviationRequiresRight').removeClass('disabled');
                $('#liClearDeviationRequiresRight').addClass('enabled');
            }
            else {
                $('#liClearDeviationRequiresRight').removeClass('enabled');
                $('#liClearDeviationRequiresRight').addClass('disabled');
            }
        } else {
            $('#liClearDeviationRequiresRight').removeClass('enabled');
            $('#liClearDeviationRequiresRight').addClass('disabled');
        }

        $('#liDetailsRequiresRight').removeClass('disabled');
        $('#liDetailsRequiresRight').addClass('enabled');
        $('#liTripRequiresRight').removeClass('disabled');
        $('#liTripRequiresRight').addClass('enabled');
        $('#liCreateTripRequiresRight').removeClass('disabled');
        $('#liCreateTripRequiresRight').addClass('enabled');
        $('#liBookingRequiresRight').removeClass('disabled');
        $('#liBookingRequiresRight').addClass('enabled');
        $('#liUpdateContainerIdRequiresRight').removeClass('disabled');
        $('#liUpdateContainerIdRequiresRight').addClass('enabled');

    }
    popUpChangeTempSetPoint() {
        self.setState({ modelTitle: 'Change Temperature Setpoint', popUpHtml: self.RenderContextMenuPopUp('ChangeTempSetPoint') });
    }

    popUpHumiditySetPoint() {
        self.setState({ modelTitle: 'Change Humidity Setpoint', popUpHtml: self.RenderContextMenuPopUp('ChangeHumiditySetPoint') });
    }

    popUpO2SetPoint() {
        self.setState({ modelTitle: 'Change O2 Setpoint', popUpHtml: self.RenderContextMenuPopUp('ChangeO2SetPoint') });
    }

    popUpCo2SetPoint() {
        self.setState({ modelTitle: 'Change CO2 Setpoint', popUpHtml: self.RenderContextMenuPopUp('ChangeCO2SetPoint') });
    }

    popUpDLTraditional() {
        self.setState({ modelTitle: 'Get Traditional Download', popUpHtml: self.RenderContextMenuPopUp('GetDLTraditional') });
    }

    popUpPreTripFull() {
        self.setState({ pretripCmd: "StartFullPTI" }, () => { self.setState({ modelTitle: 'Start Full PreTrip', popUpHtml: self.RenderContextMenuPopUp('PreTrip') }); });
    }

    popUpPreTripShort() {
        self.setState({ pretripCmd: "StartShortPTI" }, () => { self.setState({ modelTitle: 'Start Short PreTrip', popUpHtml: self.RenderContextMenuPopUp('PreTrip') }); });
    }

    popUpFunctionTest() {
        self.setState({ pretripCmd: "StartCAShortPTI" }, () => { self.setState({ modelTitle: 'Start Function Test', popUpHtml: self.RenderContextMenuPopUp('PreTrip') }); });
    }

    popUpStopPTI() {
        self.setState({ modelTitle: 'Stop PTI', popUpHtml: self.RenderContextMenuPopUp('StopPTI') });
    }

    popUpSchedulePTI() {
        self.setState({ modelTitle: 'Schedule PreTrip', popUpHtml: self.RenderContextMenuPopUp('SchedulePreTrip') });
    }

    popUpGetPTI() {
        self.setState({ modelTitle: 'Get Last PreTrip Result', popUpHtml: self.RenderContextMenuPopUp('GetPTI') });
    }

    popUpRebootReefer() {
        self.setState({ modelTitle: 'Reboot Reefer Controller', popUpHtml: self.RenderContextMenuPopUp('RebootReefer') });
    }

    popUpChangeDatalog() {
        self.setState({ modelTitle: 'Change Datalog Interval', popUpHtml: self.RenderContextMenuPopUp('ChangeDatalogInterval') });
    }

    popUpChangeReeferId() {
        self.setState({ modelTitle: 'Change Reefer ID', popUpHtml: self.RenderContextMenuPopUp('ChangeReeferId') });
    }

    popUpChangeReporting() {
        self.setState({ modelTitle: 'Change Reporting Interval', popUpHtml: self.RenderContextMenuPopUp('ChangeReportingInterval') });
    }

    popUpQueryReefer() {
        self.setState({ modelTitle: 'Query Reefer Inventory', popUpHtml: self.RenderContextMenuPopUp('QueryReeferInventory') });
    }

    popUpUpdateModelConfig() {
        self.setState({ modelTitle: 'Update Model Configuration', popUpHtml: self.RenderContextMenuPopUp('UpdateModelConfiguration') });
    }

    popUpVerifyModelValidity() {
        var verifyingModelList = [];
        //if (self.state.selectedReeferData.length > 0) {
        //    verifyingModelList = self.state.selectedReeferData.map(function (obj) {
        //        if (obj.ReeferOEMTypeCd.trim() == "TR") {
        //            return obj.ReeferOEMTypeCd;
        //        }
        //    });

        //    if (verifyingModelList.length > 0) {
        //        alert('Command is not supported for TKReceiver OEM.');
        //    }

        //}

        if (self.state.selectedReeferData.length > 0) {
            var TKReceiverCount = 0;
            $.each(self.state.selectedItems, function (key, value) {
                if (value.ReeferOEMTypeCd.trim() == "TR") {
                    TKReceiverCount++;
                }
            });

            if (TKReceiverCount == self.state.selectedReeferData.length) {
                PopupWindow.showErrorMessage("Alert", "Command is not supported for TKReceiver OEM.");

                return;
            }
        }

        self.setState({ modelTitle: 'Verify Model Validity', popUpHtml: self.RenderContextMenuPopUp('VerifyModelValidity') });
    }

    popUpSyncReeferClock() {
        self.setState({ modelTitle: 'Sync Reefer Clock', popUpHtml: self.RenderContextMenuPopUp('SyncReeferClock') });
    }

    popUpChangeReeferClockSyncSetting() {
        self.setState({ modelTitle: 'Change Reefer Clock Sync Settings', popUpHtml: self.RenderContextMenuPopUp('ChangeReeferClockSyncSettings') });
    }

    popUpStartDeforst() {
        self.setState({ modelTitle: 'Start Deforst', popUpHtml: self.RenderContextMenuPopUp('StartDeforst') });
    }

    popUpGuestReeferConfigCmd() {
        self.setState({ modelTitle: 'Guest Reefer configuration commands', popUpHtml: self.RenderContextMenuPopUp('GuestReeferConfiguration') });
    }

    popUpChangeDeforstInterval() {
        if (self.state.selectedReeferData.length > 0) {
            var reeferData = self.state.selectedReeferData;
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var TKReceiverCount = 0;
            var UnknownCount = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "TR") {
                    TKReceiverCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            this.setState({ isChangeDeforstInterval: false });

            if (OEMTypeCdCount > 0) {
                PopupWindow.showErrorMessage("Alert", "Selected reefer(s) must have a valid OEM type.");
            }
            else if (Starcoolcount == reeferData.length || CarrierCount == reeferData.length || TKReceiverCount == reeferData.length) {
                if (Starcoolcount != reeferData.length) {
                    this.setState({ isChangeDeforstInterval: true });
                }
            }
            else if (DaikinCount == reeferData.length || ThermokingCount == reeferData.length) {
                PopupWindow.showErrorMessage("Alert", "Command is not supported for Daikin and Thermoking OEMs.");
            }
            else if (UnknownCount > 0) {
                PopupWindow.showErrorMessage("Alert", "Selected reefer(s) must have a valid OEM type.");
            }
            else {
                PopupWindow.showErrorMessage("Alert", "Selected reefers must be of the same OEM type.");
            }
            self.setState({ modelTitle: 'Change Deforst Interval', popUpHtml: self.RenderContextMenuPopUp('ChangeDeforstInterval') });
        }
    }

    popUpAssignPanId() {
        self.setState({ modelTitle: 'Assign PAN ID', popUpHtml: self.RenderContextMenuPopUp('AssignPanId') });
    }

    RenderContextMenuPopUp(popUpName: string) {
        switch (popUpName) {
            case 'Ping':
                return <PingControl reeferData={self.state.selectedReeferData} refreshGrid={"details"}></PingControl>;
            case 'ChangeTempSetPoint':
                return <TempSetPoint reeferData={self.state.selectedReeferData} refreshGrid={"details"}></TempSetPoint>;
            case 'ChangeHumiditySetPoint':
                return <HumiditySetPoint reeferData={self.state.selectedReeferData} refreshGrid={"details"}></HumiditySetPoint>;
            case 'ChangeO2SetPoint':
                return <O2SetPoint reeferData={self.state.selectedReeferData} refreshGrid={"details"}></O2SetPoint>;
            case 'ChangeCO2SetPoint':
                return <CO2SetPoint reeferData={self.state.selectedReeferData} refreshGrid={"details"}></CO2SetPoint>;
            case 'GetDLTraditional':
                return <TraditionalDataDownload reeferData={self.state.selectedReeferData} refreshGrid={"details"} useremail={self.props.loggedInUserData.User.UserEmail}
                    customerId={self.props.loggedInUserData.User.Customer.CustomerId}></TraditionalDataDownload>;
            case 'PreTrip':
                return <PreTrip reeferData={self.state.selectedReeferData} refreshGrid={"details"} preTripCmd={self.state.pretripCmd}></PreTrip>;
            case 'StopPTI':
                return <StopPTI reeferData={self.state.selectedReeferData} refreshGrid={"details"}></StopPTI>;
            case 'SchedulePreTrip':
                return <ScheduledPreTrip reeferData={self.state.selectedReeferData} refreshGrid={"details"}></ScheduledPreTrip>;
            case 'GetPTI':
                return <LastPretripResult reeferData={self.state.selectedReeferData} refreshGrid={"details"} useremail={self.props.loggedInUserData.User.UserEmail}
                    customerId={self.props.loggedInUserData.User.Customer.CustomerId}></LastPretripResult>;
            case 'RebootReefer':
                return <RebootReeferController reeferData={self.state.selectedReeferData} refreshGrid={"details"}></RebootReeferController>;
            case 'ChangeDatalogInterval':
                return <ChangeDataLogInterval reeferData={self.state.selectedReeferData} refreshGrid={"details"}></ChangeDataLogInterval>;
            case 'ChangeReeferId':
                return <ChangeReeferId reeferData={self.state.selectedReeferData} refreshGrid={"details"}></ChangeReeferId>;
            case 'ChangeReportingInterval':
                return <ChangeReportingInterval reeferData={self.state.selectedReeferData} refreshGrid={"details"}></ChangeReportingInterval>;
            case 'QueryReeferInventory':
                return <QueryReeferInventory reeferData={self.state.selectedReeferData} refreshGrid={"details"}></QueryReeferInventory>;
            case 'UpdateModelConfiguration':
                return <UpdateModelConfiguration reeferData={self.state.selectedReeferData} refreshGrid={"details"}></UpdateModelConfiguration>;
            case 'VerifyModelValidity':
                return <VerifyModelValidity reeferData={self.state.selectedReeferData} refreshGrid={"details"}></VerifyModelValidity>;
            case 'SyncReeferClock':
                return <SyncReeferClock reeferData={self.state.selectedReeferData} refreshGrid={"details"}></SyncReeferClock>;
            case 'StartDeforst':
                return <StartDeforst reeferData={self.state.selectedReeferData} refreshGrid={"details"}></StartDeforst>;
            case 'ChangeDeforstInterval':
                return <ChangeDeforstInterval reeferData={self.state.selectedReeferData} refreshGrid={"details"} isChangeDeforstInterval={self.state.isChangeDeforstInterval}></ChangeDeforstInterval>;
            case 'AssignPanId':
                return <AssignPANID reeferData={self.state.selectedReeferData} refreshGrid={"details"}></AssignPANID>;
            case 'ChangeReeferClockSyncSettings':
                return <ChangeReeferClockSyncSetting reeferData={self.state.selectedReeferData} refreshGrid={"details"}></ChangeReeferClockSyncSetting>;
            case 'GuestReeferConfiguration':
                return <GuestReeferConfiguration reeferData={self.state.selectedReeferData} refreshGrid={"details"} />;
        }
    }

    public render() {
        var enableCommands = '';
        if (this.state.reeferDetailsData.ReeferID == "" || this.state.reeferDetailsData.ReeferID == null)
            enableCommands = 'disabled';
        else
            enableCommands = '';

        //let isReeferOrRCD = (this.state.DataSource == 'Reefer' || this.state.DataSource == 'Vessel') ? this.state.ReeferId : this.state.RcdId;
        //var temp = this.state.reeferDetailsData.ReeferID;

        return <div>
            <div className="row">
                <div className='col-md-12'>
                    <div className="innerpages-heading">

                        {
                            window.location.search != undefined && window.location.search != null && window.location.href != undefined &&
                                window.location.href != null && window.location.href.includes('home')
                                ?
                                <div>
                                    <Link to={'/home'}>
                                        <span className='fa-solid fa-chevron-left one-step-back' title="Back"></span>
                                    </Link>
                                    Current Details
                                </div>

                                :
                                window.location.search != undefined && window.location.search != null && window.location.href != undefined &&
                                    window.location.href != null && window.location.href.includes('reeferstatus')

                                    ?
                                    <div>
                                        <Link to={'/reeferstatus?From=' + window.location.pathname.replace('/', '')}>
                                            <span className='fa-solid fa-chevron-left one-step-back' title="Back"></span>
                                        </Link>
                                        Current Details
                                </div>
                                    :
                                    window.location.search != undefined && window.location.search != null && window.location.href != undefined &&
                                        window.location.href != null && window.location.href.includes('vesselstatus')

                                        ?
                                        <div>
                                            <Link to={'/vesselstatus?From=' + window.location.pathname.replace('/', '')}>
                                                <span className='fa-solid fa-chevron-left one-step-back' title="Back"></span>
                                            </Link>
                                            Current Details
                                        </div>
                                    :
                                    <div>
                                        <Link to={'/rcdstatus?From=' + window.location.pathname.replace('/', '')}>
                                            <span className='fa-solid fa-chevron-left one-step-back' title="Back"></span>
                                        </Link>
                                        Current Details
                                        </div>
                        }
                    </div>
                </div>
            </div>
            <div className='page-controls-container' id='reefer-details-well'>
                <div className='row'>
                    <div className='col-lg-2 text-end'>
                        <label className='col-form-label' >Reefer/Device ID :</label>
                    </div>
                    <div className='col-lg-2'>
                       
                            <input type='text' className='form-control height34' placeholder='Reefer/Device ID' onChange={e => this.Reeferchange(e)} value={this.state.searchInputValue} />
                      
                    </div>
                    <div className='col-lg-1'>
                       
                            <button type='button' className='btn btn-primary' onClick={this.ApplyReeferDetailsSearch.bind(this)}>Search</button>
                        
                    </div>
                    <div className='col-lg-3'>
                        <div className={'btn-group ' + enableCommands} id='Command'>
                            <button type='button' className='btn btn-secondary commandwidth text-align-left'>Issue New command</button>
                            <button type='button' onClick={this.commandDropdown.bind(this)} className='btn btn-secondary dropdown-toggle' data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>
                                <span className='caret'></span>
                                <span className='sr-only'>Toggle Dropdown</span>
                            </button>
                            <ul className='dropdown-menu'>
                                <li id="liPingRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpPing.bind(this)}>Ping</li>
                                <li id="liSetpointRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpChangeTempSetPoint.bind(this)}>Chg.Temp.Setpoint</li>
                                <li id="liHumidityRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpHumiditySetPoint.bind(this)}>Chg.Hum.Setpoint</li>
                                <li id="liO2SetPointRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpO2SetPoint.bind(this)}>Chg.O2 Setpoint</li>
                                <li id="liCO2SetPointRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpCo2SetPoint.bind(this)}>Chg.CO2 Setpoint</li>
                                <li id="liTraditionalDownloadRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpDLTraditional.bind(this)}>Get DL (Traditional)</li>
                                <li id="liPreTripRequiresRight" className='dropdown-submenu'>
                                    <a className='dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Start PreTrip</a>
                                    <ul className='dropdown-menu'>
                                        <li id="liFullPreTripRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpPreTripFull.bind(this)}>Full</li>
                                        <li id="liStartPreTripShortRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpPreTripShort.bind(this)}>Short</li>
                                        <li id="liStartPreTripFtRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpFunctionTest.bind(this)}>Function Test</li>
                                    </ul>
                                </li>
                                <li id="liStopPreTripRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpStopPTI.bind(this)}>Stop PTI</li>
                                <li id="liScheduledPreTripRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpSchedulePTI.bind(this)}>Scheduled PreTrip</li>
                                <li id="lilastpretripresultRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpGetPTI.bind(this)}>Get PTI Results</li>
                                <li id="liRebootReeferController" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpRebootReefer.bind(this)}>Reboot Reefer Controller</li>
                                <li id="liUpdateDatalogRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpChangeDatalog.bind(this)}>Chg.DataLog Interval</li>
                                <li id="liUpdateContainerIdRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpChangeReeferId.bind(this)}>Chg.Reefer ID</li>
                                <li id="liReportingIntervalRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpChangeReporting.bind(this)}>Chg.Reporting Interval</li>
                                <li id="liQueryReeferInventoryRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpQueryReefer.bind(this)}>Query Reefer Inventory</li>
                                <li id="liUpdateModelConfigurationRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpUpdateModelConfig.bind(this)}>Update Model Configuration</li>
                                <li id="liVerifyModelValidityRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpVerifyModelValidity.bind(this)}>Verify Model Validity</li>
                                <li id="liSyncReeferClockRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpSyncReeferClock.bind(this)}>Sync.Reefer Clock</li>
                                <li id="lichangereeferclocksettingRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpChangeReeferClockSyncSetting.bind(this)}>Change Reefer Clock Sync Settings</li>
                                <li id="liDefrostRequiresRight" className='dropdown-submenu'>
                                    <a className='dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Deforst</a>
                                    <ul className='dropdown-menu'>
                                        <li id="liStartDefrostRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpStartDeforst.bind(this)}>Start Deforst</li>
                                        <li id="liChangeDefrostIntervalRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpChangeDeforstInterval.bind(this)}>Chg.Deforst Interval</li>
                                    </ul>
                                </li>
                                <li id="liassignpanidRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpAssignPanId.bind(this)}>Assign PAN Id</li>
                                <li id="liassignGuestreeferRequiresRight" data-bs-toggle="modal" data-bs-backdrop="static" data-bs-target="#contextMenuModel" onClick={this.popUpGuestReeferConfigCmd.bind(this)}>Guest Reefer configuration</li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-md-6'>
                    </div>
                </div>
                <div className='row'>
                    <div className="modal fade" id="contextMenuModel" role="dialog">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header" id="contextMenuModelHeader">
                                    <h5 className="modal-title">{this.state.modelTitle}</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                                   
                                </div>
                                <div className="modal-body">
                                    {this.state.popUpHtml}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id='reefer-details-tab'>
                <ul className="nav nav-underline" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="lnkCurrentStatus" data-bs-toggle="pill" data-bs-target="#tabContentBlock" type="button" role="tab" aria-selected="true">Current Status</button>
                        
                    </li>
                    <li className="nav-item d-none" role="presentation">
                        <button className="nav-link" id="lnkHistory" data-bs-toggle="pill" data-bs-target="#tabContentBlock" type="button" role="tab" aria-selected="true">History</button>
                       
                    </li>
                    <li className="nav-item" role="presentation">
                       
                        <button className="nav-link" id="lnkCommandStatus" data-bs-toggle="pill" data-bs-target="#tabContentBlock" type="button" role="tab" aria-selected="true">Command Status</button>
                    </li>
                </ul>
                <div id="tabContentBlock" className="tab-content">
                    {this.state.tabContentHtml}
                </div>
            </div>
        </div>
    }

}

export default connect(
    (state: ApplicationState) => ({ ...state.userDetails, ...state.reeferStatus }), // Selects which state properties are merged into the component's props
    ReeferStatusState.actionCreators,
)(ReeferDetails as any);


class ReeferDetailsFilter {
    ReeferId: string;
    RcdId: string;
}
class UnitDetailsUI {
    ICCID: string;
    Geofence: string;
    GeofenceName: string;
    RevisionNum?: number;
    RSSI?: number;
    MNC?: number;
    TowerLocalizationAreaCode?: number;
    TowerBaseStationID?: number;
    GPSLockState: string;
    GPSLastLock?: number;
    GPSLongitude?: number;
    GPSLatitude?: number;
    ReeferSwitchOn?: boolean;
    IsReeferPhysicallyConnected?: boolean;
    BatteryVoltage?: number;
    DeviceTemp?: number;
    ReeferACPowerLevel?: number;
    DisplaySerNum: string;
    AtmContSerNum: string;
    PwrMeasureSerNum: string;
    HumSensorSerNum: string;
    BookedTemperature?: number;
    TripName: string;
    TripRouteWaypointId?: number;
    TripNameAndStatus: string;
    TripDefStatusDsc: string;
    TripStatusCd: string;
    TripId?: number;
    ModifiedDTTM?: Date;
    RCDRfrComErr?: boolean;
    ReeferClockInSync?: boolean;
    OemModelID?: number;
    ControllerTypeCd?: number;
    ReeferConfigTypeCd: string;
    ModelNumber: string;
    FreqConverterSerNum: string;
    CO2SensorSerNum: string;
    O2SensorSerNum: string;
    ReeferOEMTypeCd: string;
    RCDPowerSourceCd: string;
    TemperatureUnit: string;
    SIM_IMSI: string;
    UnitTypeCd: string;
    CondenserPressure?: number;
    DischargePressure?: number;
    CompositeSuctionPressure?: number;
    VentPositionSensorCMH?: number;
    CO2Setpoint?: number;
    O2Setpoint?: number;
    AlarmsList: string;
    HumiditySetpoint?: number;
    SoftwareRevision: string;
    PretripTestStateID?: any;
    EventMasterID?: number;
    EventDTTM?: Date;
    ParentEventID: number;
    ReeferID: string;
    UnitMasterID?: number;
    SetPoint?: number;
    ReturnTemp1?: number;
    SupplyTemp1?: number;
    AmbientTemp?: number;
    MSISDN: string;
    RCDReportingInterval?: number;
    RCDMeshFirmwareVersion: string;
    RCDBootloaderVersion: string;
    RCDFirmwareVersion: string;
    RCDID: string;
    RCDMasterID?: number;
    Cargo4Temp?: number;
    USDA3Temp?: number;
    USDA2Temp?: number;
    USDA1Temp?: number;
    ControlModeID?: any;
    LineFrequency?: number;
    CompressorSuctionTemp?: number;
    ThreePhaseCurrent: string;
    SupplyTemp2?: number;
    ReturnTemp2?: number;
    BookingNumber: string;
    DeviceConfig?: boolean;
    DevicePowerSourceCd: string;
    RunState: string;
    OEMModel: string;
    ControllerDesc: string;
    OEMModelDesc: string;
    IsValid3P: boolean;
    AssetMasterID?: number;
    CustCd3P: string;
    CustName3P: string;
    ControllerTypeSetting: string;
    OEParams: string;
    OverallResult: string;
    TripWiseResultDescription: string;
    TWDateTime?: Date;
    IsReeferCommunicationEstablished?: boolean;
    LineFrequencyQualifier?: any;
}